import { hash } from '@ember/helper';

import BillingCostEstimatorQuery from './cost-estimator/query.gjs';

<template>{{yield (hash Query=BillingCostEstimatorQuery)}}</template>
